import picsioConfig from '../../../../../config';
/**
 * Download zipped assets on proofing website
 */
export default async function downloadWebsiteZip() {
  window.open(
    `${picsioConfig.zipperZipUrl}?websiteId=${picsioConfig.access._id}&mimeType=original&resizing=original`,
    '_blank',
  );
}
